import { LimiteAdicionalTranch } from './../../../model/limite-adicional-tranch.model';
import {
  Component
} from '@angular/core';


import { Tranche } from 'src/app/model/tranche.model';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';

import { ModalidadeGarantia } from 'src/app/model/modalidade_garantia.model';
import { ModalidadeGarantiaService } from '../../modalidade_garantia/modalidade-garantia.service';

import { BaseEntityComponent } from '@bndes/bndes-ux4/bndes-angular-utils';
import { ActivatedRoute, Router } from '@angular/router';
import { LimiteAdicionalService } from '../limite-adicional.service';

@Component({
  selector: 'app-limite-adicional-tranch-listagem',
  templateUrl: './limite-adicional-tranch-listagem.component.html',
  styleUrls: ['./limite-adicional-tranch-listagem.component.scss'],
  standalone: false,
})
export class LimiteAdicionalTranchListagemComponent extends  BaseEntityComponent<LimiteAdicionalTranch> {

  public tranches: Tranche[] = [];
  public limiteAdicional : LimiteAdicionalTranch[] =[];
  public ideTranche: number;

  public podeCadastrar: boolean;
  public idLimite: number;

  public modalidade: ModalidadeGarantia;

  constructor(
    private modalidadeGarantiaService: ModalidadeGarantiaService,
    private limiteAdiconal : LimiteAdicionalService,
    private trancheService: TrancheService,
    private permissaoService: PermissaoService,
    protected route : ActivatedRoute,
    protected router : Router
  ) {
        super(limiteAdiconal);
  }

  ngOnInit() {

    this.formGroup = this.formBuilder.group({
      idLimite:[null]
    });

      this.route.params.subscribe(params =>{
      this.ideTranche = params['ideTranche'];

    })

    this.permissaoService
      .getPermissoesUsuarioAutenticado()
      .subscribe(resp => {

        this.podeCadastrar = resp && resp[ROLE_GESTOR_ENVIO];

        this.modalidadeGarantiaService
          .buscarModalidade()
          .subscribe((modalidade: any) => {
            this.modalidade = modalidade;
          });
      });

      this.trancheService.buscarLimitesAdicionaisTranche(this.ideTranche).subscribe(limite => {
          this.limiteAdicional = limite;
    });
  }

  voltarParaLista (){
    this.router.navigate(['limite-adicional/pesquisa']);
  }

  editar(){
    const idLimite = this.formGroup.get('idLimite')?.value;
    this.router.navigate(['/limite-adicional/cadastro/',this.ideTranche, idLimite])

  }
}
